import { observable, makeObservable, action } from "mobx";
var Aggregator = /** @class */ (function () {
    function Aggregator() {
        var _this = this;
        // mobx proxy workaround
        Object.defineProperty(this, "_widgets", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: observable.map({})
        });
        // mobx proxy workaround
        Object.defineProperty(this, "_forms", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: observable.map({})
        });
        Object.defineProperty(this, "makeObservable", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function () {
                makeObservable(_this, {
                    _widgets: observable,
                    _forms: observable,
                    addWidget: action,
                    addForm: action,
                });
            }
        });
        Object.defineProperty(this, "hasWidget", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function (path) {
                return _this.widgets.has(path);
            }
        });
        Object.defineProperty(this, "addWidget", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function (path, widget) {
                _this.widgets.set(path, widget);
            }
        });
        Object.defineProperty(this, "removeWidget", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function (path) {
                _this.widgets.delete(path);
            }
        });
        Object.defineProperty(this, "getWidget", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function (path) {
                return _this.widgets.get(path);
            }
        });
        Object.defineProperty(this, "matchWidgets", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function (path) {
                var result = [];
                _this.widgets.forEach(function (widget) {
                    if (widget.path.startsWith(path)) {
                        result.push(widget);
                    }
                });
                return result;
            }
        });
        Object.defineProperty(this, "hasForm", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function (path) {
                return _this.forms.has(path);
            }
        });
        Object.defineProperty(this, "addForm", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function (path, form) {
                _this.forms.set(path, form);
            }
        });
        Object.defineProperty(this, "getForm", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function (path) {
                return _this.forms.get(path);
            }
        });
        Object.defineProperty(this, "removeForm", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function (path) {
                _this.forms.delete(path);
            }
        });
        this.makeObservable();
    }
    Object.defineProperty(Aggregator.prototype, "widgets", {
        get: function () {
            return this._widgets;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Aggregator.prototype, "forms", {
        get: function () {
            return this._forms;
        },
        enumerable: false,
        configurable: true
    });
    return Aggregator;
}());
export { Aggregator };
